/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.SITECORE_API_KEY || 'no-api-key-set';
config.sitecoreApiHost = process.env.SITECORE_API_HOST || 'http://cm';
config.sitecoreSiteName = process.env.SITECORE_SITE_NAME || 'AdvocateHealthCom';
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge';
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || 'en';
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || 'http://cm/sitecore/api/graph/edge';
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'sxa-jss';
config.publicUrl = process.env.PUBLIC_URL || 'https://advocatehealthcom.enterprisedev.local';
config.disableFetchSiteInformation = process.env.DISABLE_FETCH_SITE_INFORMATION || '1';
config.buildId = process.env.BUILD_ID || '337ff73f97f4bb90a080f25d487632b32d887fc3';
config.appinsightsConnectionString = process.env.APPINSIGHTS_CONNECTION_STRING || '';
config.renderingEnv = process.env.RENDERING_ENV || 'undefined';
config.sites = process.env.SITES || '[]';
module.exports = config;